import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ children, modalClassname }) => {
  const elRef = useRef(null);

  if (!elRef.current) {
    const div = document.createElement('div');
    div.className = modalClassname;
    elRef.current = div;
  }

  useEffect(() => {
    const modalRoot = document.body;
    modalRoot.appendChild(elRef.current);

    return () => modalRoot.removeChild(elRef.current);
  }, []);

  return ReactDOM.createPortal(children, elRef.current);
};

export default Modal;
